export enum WIDGET_ID {
  CHANGE_CHART = 'CHANGE_CHART',
  RISK_DISTRIBUTION = 'RISK_DISTRIBUTION',
  RISK_LEVEL = 'RISK_LEVEL',
  RECENT_RP_CHANGES = 'RECENT_RP_CHANGES',
}

export interface WidgetMetricDto {
  id: string;
  name: string;
}

export interface WidgetMetricResponseDto {
  widgetId: WIDGET_ID;
  metrics: WidgetMetricDto[];
}
